<div class="hts-assistant-thinking" aria-live="polite">
  <div class="hts-assistant-thinking__dots">
    <i></i>
    <i></i>
    <i></i>
  </div>
  <span class="hts-assistant-thinking__label">{{ "HTS_ASSISTANT.THINKING" | translate }}</span>
</div>
